export const uploadHelper = (event, id, dispatch, actionFn) => {
	const file = event.target.files[0]
	const fileName = event.target.files[0].name

	return dispatch(actionFn.upload(file, fileName, id))
}